import { ChevronDown } from 'lucide-react';

const FAQ = ({ openFAQ, setOpenFAQ }) => {
  const faqData = [
    {
      question: "What are the evaluation criteria for becoming a funded trader?",
      answer: "To qualify for funding, you'll need to hit the profit target set for your chosen evaluation while respecting the program's rules. These include daily and overall drawdown limits, minimum trading days (where applicable), and consistency requirements. By showing steady performance within these guidelines, you'll move on to a funded account and start receiving payouts."
    },
    {
      question: "How quickly are payouts processed for funded traders?",
      answer: "Once you're funded, you can request a payout every 14 days. After submitting your request, our team reviews it and processes payments as quickly as possible — typically within a short timeframe, so you're not left waiting."
    },
    {
      question: "What trading platforms are available for prop traders?",
      answer: "Nexxo Funded gives you access to industry-leading platforms including MetaTrader 5 (MT5), cTrader, and TradeLocker. Each platform offers real-time data, advanced charting, and powerful tools to help you trade with confidence across desktop, web, and mobile."
    },
    {
      question: "What support and resources are available for prop traders?",
      answer: "At Nexxo Funded, we offer 24/7 support through live chat, email, Discord, and our ticketing system, so help is always close by. Traders also gain access to valuable resources, including market insights, educational content, and updates available directly in the dashboard and on our blog."
    },
    {
      question: "What are the risk management guidelines for prop traders?",
      answer: "Every evaluation and funded account comes with defined rules — including daily drawdown limits, maximum overall drawdown, and consistency requirements. To remain eligible, traders must follow these risk guidelines at all times. For full details, please review the program rules, terms and conditions, and prohibited practices listed in our knowledge center."
    }
  ];

  return (
    <div className="mb-16">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-6 bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
            Frequently Asked Questions
          </h2>
        </div>

        {/* Two Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          {/* Left Column - Introduction */}
          <div className="bg-gray-800/50 rounded-xl p-6">
            <h3 className="text-xl font-bold mb-4 text-white">
              Getting Started
            </h3>
            <p className="text-gray-400 text-lg leading-relaxed mb-6 font-medium">
              Got questions? We've got answers. Browse our FAQ section to find clear explanations and extra guidance on everything from evaluations to payouts.
            </p>
            <p className="text-gray-300 text-base leading-relaxed mb-4">
              Joining is simple. First, choose your evaluation type and account size. Once you sign up, you'll receive access to a simulated trading account. From there, your goal is to reach the profit target while following the risk management rules. If you succeed, you'll unlock a funded account where you can trade and earn real payouts.
            </p>
            <p className="text-gray-300 text-base leading-relaxed">
              Just select your evaluation and begin trading all you need to do is follow the program rules and stay within the terms and conditions.
            </p>
          </div>

          {/* Right Column - FAQ Items */}
          <div className="space-y-4">
            {faqData.map((faq, idx) => (
              <div key={idx} className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl border border-gray-700 overflow-hidden hover:border-gray-600 transition-all duration-300">
                <button
                  onClick={() => setOpenFAQ(openFAQ === idx ? null : idx)}
                  className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-800/50 transition-colors duration-200"
                >
                  <span className="text-white font-medium text-left leading-relaxed flex-1 mr-4">
                    {faq.question}
                  </span>
                  <div className={`flex-shrink-0 transition-transform duration-200 ${openFAQ === idx ? 'rotate-180' : ''}`}>
                    <ChevronDown size={20} className="text-cyan-400" />
                  </div>
                </button>
                
                {openFAQ === idx && (
                  <div className="px-6 pb-5 border-t border-gray-700/50 animate-slide-up">
                    <p className="text-gray-300 leading-relaxed pt-4">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
